module.exports = __webpack_public_path__ + "static/media/6. Ondas, Óleo y barniz sobre lámina de acrílico y papel, 28.5 x 21 cm, 2012 copy.ea3e1889.png";